const redirects: Record<string, string> = {
    "app.seniorplace.io": "app.seniorplace.com",
    "staging.seniorplace.io": "staging.seniorplace.com",
};

export const shouldRedirectDomain = (): boolean => {
    const hostname = window.location.hostname;
    return hostname in redirects;
};

export const getRedirectUrl = (): string => {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;

    const newHostname = redirects[hostname] || hostname;

    return `${protocol}//${newHostname}/`;
};

export const performDomainRedirect = (): void => {
    if (shouldRedirectDomain()) {
        window.location.replace(getRedirectUrl());
    }
};

export const redirectDomainIfNeeded = (): boolean => {
    if (shouldRedirectDomain()) {
        performDomainRedirect();
        return true;
    }
    return false;
};
